import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Make sure release-notes.json sits right next to this file
import notes from './release-notes.json';

const ReleaseNotes = () => {
  const sortedNotes = [...notes].sort((a, b) => b.id - a.id);
  return (
    <Box
      sx={{
        maxWidth: 600,
        width: '100%',
        mx: 'auto',
        mt: 6,
        mb: 4,
        px: 2,
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2', textAlign: 'left' }}>
        Release Notes
      </Typography>

      {sortedNotes.map(({ id, version, date, changes }) => (
        <Accordion key={id} sx={{ mb: 1 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: 'medium' }} align="left">
              v{version} — {date}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ textAlign: 'left' }}>
            <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
              {changes.map((c, i) => (
                <li key={i}>
                  <Typography variant="body2" align="left">
                    {c}
                  </Typography>
                </li>
              ))}
            </ul>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default ReleaseNotes;
